<template>
  <div class="yxtbiz-place-selector__cont" ref="rightCont">
    <div class="lh40 clearfix" ref="rightHeader">
      <div class="clearfix">
        <div class="pull-left pr24 yxtbiz-place-selector__filter" slot="reference">
          <yxt-button
            plain 
            @click.stop="onFilterClick"
            class="filter-btn"
          >
            <i class="yxtbiz-place-selector__icon-filter"><yxt-svg icon-class="filter" /></i>
            <span class="more">{{$t('pc_biz_common_lbl_moreFilter'/* 更多筛选 */)}}</span>
            <i :class="filterPanelVisible ? 'yxt-icon-arrow-up': 'yxt-icon-arrow-down'"></i>
          </yxt-button>
        </div>
        <div class="pull-left pr24 mb16">
          <yxtbiz-auth-selector width="200"
            class="yxtbiz-place-selector__select"
            @change="permissionChange"
            type="2"
          >
            <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_common_lbl_permission'/* 权限 */)}}：</span>
          </yxtbiz-auth-selector>
        </div>
        <div class="pull-left pr24 mb16">
          <yxt-input
            searchable
            :placeholder="$t('pc_biz_place_tip_search'/* 请输入场地、地址进行搜索 */)"
            v-model="searchInputText"
            @change="refreshTable({currentPage: 1})"
            maxlength="50"
            minlength="0"
          ></yxt-input>
        </div>
        <div class="pull-left mb16 d-in-block yxtbiz-place-selector__filter-selected"  v-if="showPriceSelect">
          <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_common_lbl_price'/* 价格 */)}}：</span>
          <yxt-select style="width:150px"
            v-model="priceSelectVal"
            class="mr20"
            @change="priceChange"
          >
            <yxt-option
              v-for="item in priceSelectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></yxt-option>
          </yxt-select>
          <i class="yxt-icon-error" @click.stop="clear('showPriceSelect')"></i>
        </div>
        <div class="pull-left d-in-block mb16 yxtbiz-place-selector__filter-selected" v-if="showPeopleSelect">
          <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_place_lbl_userCount'/* 人数 */)}}：</span>
          <yxt-select style="width:150px"
            v-model="peopleSelectVal"
            :placeholder="$t('pc_biz_udp_lbl_unlimited'/* 不限 */)"
            class="mr20"
            @change="peopleChange"
          >
            <yxt-option
              v-for="item in peopleSelectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></yxt-option>
          </yxt-select>
          <i class="yxt-icon-error" @click.stop="clear('showPeopleSelect')"></i>
        </div>
        <div v-if="typeSelectList.length > 1 && showTypeSelect" class="pull-left mb16 d-in-block yxtbiz-place-selector__filter-selected">
          <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_survey_lbl_type'/* 类型 */)}}：</span>
          <yxt-select style="width:150px"
            v-model="typeSelectVal"
            :placeholder="$t('pc_biz_udp_lbl_unlimited'/* 不限 */)"
            class="mr20"
            @change="typeChange"
          >
            <yxt-option
              v-for="item in typeSelectList"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            ></yxt-option>
          </yxt-select>
          <i class="yxt-icon-error" @click.stop="clear('showTypeSelect')"></i>
        </div>
        <span class="yxtbiz-place-selector__filter-clear color-primary-6 pull-left mb16" v-if="showPeopleSelect || showPriceSelect || showTypeSelect" @click="clearAll">清空</span>
      </div>
      <div class="yxtbiz-place-selector__filter-panel clearfix" v-show="filterPanelVisible">
        <div class="yxtbiz-place-selector__filter-cont">
          <div class="yxtbiz-place-selector__filter-left pull-left bg-gray-1" @click="filterPanelVisible = false"><yxt-button plain>{{$t('pc_biz_place_btn_close'/* 关闭筛选 */)}}</yxt-button></div>
          <div class="yxtbiz-place-selector__filter-right pull-left">
            <div class="pull-left pr24 pb16 d-in-block">
              <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_common_lbl_price'/* 价格 */)}}：</span>
              <yxt-select style="width:200px"
                v-model="priceSelectVal"
                class="mr20"
                @change="priceChange"
              >
                <yxt-option
                  v-for="item in priceSelectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></yxt-option>
              </yxt-select>
            </div>
            <div class="pull-left pr24 pb16 d-in-block">
              <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_place_lbl_userCount'/* 人数 */)}}：</span>
              <yxt-select style="width:200px"
                v-model="peopleSelectVal"
                :placeholder="$t('pc_biz_udp_lbl_unlimited'/* 不限 */)"
                class="mr20"
                @change="peopleChange"
              >
                <yxt-option
                  v-for="item in peopleSelectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></yxt-option>
              </yxt-select>
            </div>
            <div v-if="typeSelectList.length > 1" class="pr24 pb16 pull-left d-in-block">
              <span class="font-size-14 color-gray-9 mr5">{{$t('pc_biz_survey_lbl_type'/* 类型 */)}}：</span>
              <yxt-select style="width:200px"
                v-model="typeSelectVal"
                :placeholder="$t('pc_biz_udp_lbl_unlimited'/* 不限 */)"
                class="mr20"
                @change="typeChange"
              >
                <yxt-option
                  v-for="item in typeSelectList"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                ></yxt-option>
              </yxt-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span></span>
    <yxt-table
      v-loading="loading"
      ref="table"
      :height="tableHeight"
      :data="tableData"
      style="width: 662px"
      @sort-change="onSortChange"
    >
      <yxt-table-column prop="placeName" :label="$t('pc_biz_place_lbl_place'/* 场地 */)" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="hand" @click="preview(scope.row.id)">{{scope.row.placeName}}</span>
        </template>
      </yxt-table-column>
      <yxt-table-column prop="prize" :label="$t('pc_biz_common_lbl_price'/* 价格 */)" sortable="custom">
        <template slot-scope="scope">
          <div>
            <span
              v-if="scope.row.prize"
            >{{scope.row.prize}}{{$t('pc_biz_common_lbl_yuan'/* 元 */)}}/{{scope.row.prizeCalendar == 1 ? $t('pc_biz_common_lbl_day'/* 天 */):$t('pc_biz_common_lbl_hour'/* 时 */)}}</span>
            <span v-else>{{$t('pc_biz_common_lbl_free'/* 免费 */)}}</span>
          </div>
        </template>
      </yxt-table-column>
      <yxt-table-column prop="participantCount" :label="$t('pc_biz_place_lbl_capacity'/* 容纳人数 */)" sortable="custom" width="120"></yxt-table-column>
      <yxt-table-column prop="square" :label="$t('pc_biz_place_lbl_area'/* 面积 */) +'（㎡）'" sortable="custom" width="135"></yxt-table-column>
      <yxt-table-column prop="completeAddr" :label="$t('pc_biz_place_lbl_position'/* 地址 */)" :show-overflow-tooltip="true"></yxt-table-column>
      <yxt-table-column :label="$t('pc_biz_te_lbl_operation'/* 操作 */)" width="120" align="right">
        <template slot-scope="scope">
          <yxt-button type="text" class="hand" @click="preview(scope.row.id)">{{$t('pc_biz_imgcropper_btn_preview'/* 预览 */)}}</yxt-button>
          <yxt-divider direction="vertical"></yxt-divider>
          <yxt-button type="text" class="hand" @click="select(scope.row.id)">{{$t('pc_biz_cer_btn_select'/* 选择 */)}}</yxt-button>
        </template>
      </yxt-table-column>
    </yxt-table>
    
    <div class="yxtbiz-place-selector__pagination" ref="rightFooter" v-if="paging.pages > 1">
      <yxt-pagination
        class="pull-right"
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        :current-page.sync="paging.current"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="paging.limit"
        :layout="(paging.count < paging.limit)? 'total' : 'total, prev, pager, next, jumper'"
        :total="paging.count"
      ></yxt-pagination>
    </div>
  </div>
</template>

<script>
import { getPlaceList, getPlaceById, getConflicts, getPlaceTypeList } from '../service';
import resizeTable from '../../mixins/resizeTable';
import AuthSelector from 'yxt-biz-pc/packages/auth-selector';
import {
  Select,
  Option,
  Pagination,
  Table,
  TableColumn,
  Divider
} from 'yxt-pc';
let isFirstSearch = true;

export default {
  mixins: [resizeTable],
  components: {
    YxtbizAuthSelector: AuthSelector,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtSelect: Select,
    YxtOption: Option,
    YxtPagination: Pagination,
    YxtDivider: Divider
  },
  props: {
    address: String,
    searchInput: String
  },
  data() {
    return {
      showPriceSelect: false,
      showPeopleSelect: false,
      showTypeSelect: false,
      loading: true,
      filterPanelVisible: false,
      permissionVal: 0,
      priceSelectVal: 0,
      peopleSelectVal: 0,
      typeSelectVal: 0,
      currentPage: 1,
      searchInputText: this.address || '',
      tableHeight: 0,
      tableData: [],
      sort: 0,
      paging: {
        count: 0,
        limit: 10,
        current: 1,
        pages: 0
      },
      priceSelectList: [{
        value: 0,
        label: this.$t('pc_biz_udp_lbl_unlimited'/* 不限 */)
      }, {
        value: '0-0',
        label: this.$t('pc_biz_common_lbl_free'/* 免费 */)
      }, {
        value: '1-1000',
        label: '<1000' + this.$t('pc_biz_common_lbl_yuan'/* 元 */)
      }, {
        value: '1000-3000',
        label: '1000-3000' + this.$t('pc_biz_common_lbl_yuan'/* 元 */)
      }, {
        value: '3001-5000',
        label: '3001-5000' + this.$t('pc_biz_common_lbl_yuan'/* 元 */)
      }, {
        value: '5001-10000',
        label: '5001-10000' + this.$t('pc_biz_common_lbl_yuan'/* 元 */)
      }, {
        value: '10001-30000',
        label: '10001-30000' + this.$t('pc_biz_common_lbl_yuan'/* 元 */)
      }, {
        value: '30001-',
        label: '≥30001' + this.$t('pc_biz_common_lbl_yuan'/* 元 */)
      }],
      peopleSelectList: [{
        value: 0,
        label: this.$t('pc_biz_udp_lbl_unlimited'/* 不限 */)
      }, {
        value: '0-30',
        label: '<30' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }, {
        value: '31-50',
        label: '31-50' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }, {
        value: '51-100',
        label: '51-100' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }, {
        value: '101-200',
        label: '101-200' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }, {
        value: '201-500',
        label: '201-500' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }, {
        value: '501-1000',
        label: '501-1000' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }, {
        value: '1001-',
        label: '≥1000' + this.$t('pc_biz_common_lbl_people'/* 人 */)
      }],
      typeSelectList: [
        {
          id: 0,
          typeName: this.$t('pc_biz_udp_lbl_unlimited'/* 不限 */)
        }
      ]
    };
  },
  watch: {
    searchInput(val) {
      this.searchInputText = val;
    }
  },
  mounted() {
    getPlaceTypeList().then(res => {
      if (res && res.datas) {
        this.typeSelectList = this.typeSelectList.concat(res.datas);
      }
    });
  },
  methods: {
    onFilterClick() {
      this.filterPanelVisible = !this.filterPanelVisible;
    },
    /* 人员管辖范围方法 */
    permissionChange(val) {
      this.permissionVal = val;
      this.refreshTable({ currentPage: 1 });
    },
    onPageSizeChange(val) {
      this.paging.limit = val;
      this.refreshTable({ currentPage: 1 });
    },
    onPageChange(val) {
      this.paging.current = val;
      this.refreshTable();
    },
    onSortChange({ prop, order: sort }) {
      if (sort) {
        switch (prop) {
          case 'prize':
            this.sort = sort === 'asc' ? 1 : 2;
            break;
          case 'participantCount':
            this.sort = sort === 'asc' ? 3 : 4;
            break;
          case 'square':
            this.sort = sort === 'asc' ? 5 : 6;
            break;
        }
      } else {
        this.sort = 0;
      }
      this.refreshTable({ currentPage: 1 });
    },
    typeChange() {
      this.showTypeSelect = true;
      this.refreshTable({currentPage: 1});
    },
    peopleChange() {
      this.showPeopleSelect = true;
      this.refreshTable({currentPage: 1});
    },
    priceChange() {
      this.showPriceSelect = true;
      this.refreshTable({currentPage: 1});
    },
    refreshTable(params) {
      this.loading = true;
      params && params.currentPage && (this.paging.current = params.currentPage);
      let data = {
        size: this.paging.limit,
        current: this.paging.current,
        permission: this.permissionVal,
        nameOrAddr: this.searchInputText
      };
      if (isFirstSearch) {
        this.provinceId && (data.provinceId = this.provinceId);
        this.cityId && (data.cityId = this.cityId);
        this.districtId && (data.districtId = this.districtId);
        isFirstSearch = false;
      }
      if (params && params.categoryId && params.categoryId !== '0') {
        this.categoryId = params.categoryId;
      } else if (params && params.categoryId === '0') {
        this.categoryId = null;
      }
      this.categoryId && (data.categoryId = this.categoryId);
      this.typeSelectVal && (data.typeId = this.typeSelectVal);
      this.sort && (data.orderQuery = this.sort);
      this.priceSelectVal && (data.prize = this.priceSelectVal);
      this.peopleSelectVal && (data.participantCount = this.peopleSelectVal);
      getPlaceList(data).then(res => {
        if (res) {
          this.tableData = res.datas;
          this.paging.count = parseInt(res.paging.count, 10);
          this.paging.pages = parseInt(res.paging.pages, 10);
        } else {
          this.tableData = [];
          this.paging.count = 0;
          this.paging.pages = 0;
        }
        this.tableHeight = 0;
        this.$refs.table.doLayout();
        this.$nextTick(() => {
          this.updateSize();
        });
        this.loading = false;
      }, res => {
        this.loading = false;
        this.tableData = [];
        this.paging.count = 0;
        this.paging.pages = 0;
      });
    },
    /* 操作 */
    preview(id) {
      window.open(`${window.location.protocol}//${window.location.host}/place/#/preview/${id}`);
    },
    select(id) {
      if (this.startTime) {
        // 检验冲突，dialog提示
        this.checkConfict(id).then(() => {
          this.success(id);
        }, err => {
          console.error(err);
        });
      } else {
        this.success(id);
      }
    },
    success(id) {
      getPlaceById(id).then(res => {
        if (res) {
          this.$emit('complete', {
            place_id: res.id,
            province_id: res.provinceId,
            province_name: res.provinceName,
            city_id: res.cityId,
            city_name: res.cityName,
            district_id: res.districtId,
            district_name: res.districtName,
            address: res.address
          });
        }
      });
    },
    checkConfict(id) {
      let data = {
        placeIds: id
      };
      if (this.startTime) {
        data.startTime = this.startTime;
      }
      if (this.endTime) {
        data.endTime = this.endTime;
      }
      return getConflicts(data);
    },
    clear(key) {
      if (key === 'showPeopleSelect') {
        this.showPeopleSelect = false;
        this.peopleSelectVal = 0;
      }
      if (key === 'showPriceSelect') {
        this.showPriceSelect = false;
        this.priceSelectVal = 0;
      }
      if (key === 'showTypeSelect') {
        this.showTypeSelect = false;
        this.typeSelectVal = 0;
      }
      this.refreshTable({currentPage: 1});
    },
    clearAll() {
      this.showPriceSelect = false;
      this.showPeopleSelect = false;
      this.showTypeSelect = false;
      this.priceSelectVal = 0;
      this.peopleSelectVal = 0;
      this.typeSelectVal = 0;
      this.refreshTable({currentPage: 1});
    }
  }
};

</script>
